<template>
  <div v-if="diff" class="insured-update-inline-diff" role="status">
    <span class="insured-update-inline-diff__old">
      <span class="insured-update-inline-diff__tag">{{ $t("insuredUpdateWas") }}</span>
      {{ diff.oldDisplay }}
    </span>
    <i class="bi bi-arrow-right insured-update-inline-diff__arrow" aria-hidden="true"></i>
    <span class="insured-update-inline-diff__new">
      <span class="insured-update-inline-diff__tag">{{ $t("insuredUpdateNow") }}</span>
      {{ diff.newDisplay }}
    </span>
  </div>
</template>

<script>
export default {
  name: "InsuredUpdateFieldHint",
  props: {
    diff: {
      type: Object,
      default: null,
    },
  },
};
</script>
